import { render, staticRenderFns } from "./ConsuntivoWorkOrder.vue?vue&type=template&id=522b60cc&scoped=true&"
import script from "./ConsuntivoWorkOrder.vue?vue&type=script&lang=js&"
export * from "./ConsuntivoWorkOrder.vue?vue&type=script&lang=js&"
import style0 from "./ConsuntivoWorkOrder.vue?vue&type=style&index=0&id=522b60cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b60cc",
  null
  
)

export default component.exports